export { carouselNavigationVariables as carouselNavigationItemVariables } from './carouselNavigationVariables';
